/* eslint-disable max-len, i18next/no-literal-string */
import React from 'react';

export function Monitor(props): JSX.Element {
  return (
    <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <title>Monitor</title>
      <rect x='4' y='7' width='42' height='27' rx='3' stroke='#153F66' strokeWidth='2' />
      <rect x='9' y='12' width='6' height='6' rx='1' stroke='#FF3E51' strokeWidth='2' />
      <rect x='9' y='22' width='6' height='6' rx='1' stroke='#FF3E51' strokeWidth='2' />
      <rect x='22' y='12' width='6' height='6' rx='1' stroke='#FF3E51' strokeWidth='2' />
      <rect x='22' y='22' width='6' height='6' rx='1' stroke='#FF3E51' strokeWidth='2' />
      <rect x='35' y='12' width='6' height='6' rx='1' stroke='#FF3E51' strokeWidth='2' />
      <rect x='35' y='22' width='6' height='6' rx='1' stroke='#FF3E51' strokeWidth='2' />
      <rect x='19' y='34' width='12' height='9' rx='1' stroke='#153F66' strokeWidth='2' />
      <line x1='16' y1='43' x2='34' y2='43' stroke='#153F66' strokeWidth='2' />
    </svg>
  );
}
